function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBarGraph = function SvgBarGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8190_11883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1495 44 44 34.1495 44 22C44 9.8505 34.1495 0 22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44Z",
    fill: "#EAEAEA",
    style: _defineProperty(_defineProperty({
      fill: "#EAEAEA"
    }, "fill", "color(display-p3 0.9188 0.9188 0.9188)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2078 33.2307H11.7918C11.1868 33.2307 10.6973 32.7412 10.6973 32.1362V12.8367C10.6973 12.2317 11.1868 11.7422 11.7918 11.7422C12.3968 11.7422 12.8863 12.2317 12.8863 12.8367V31.0472H32.2133C32.8183 31.0472 33.3078 31.5367 33.3078 32.1417C33.3078 32.7467 32.8183 33.2362 32.2133 33.2362L32.2078 33.2307Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3697 22.9619H14.8662V28.7974H18.3697V22.9619Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1656 16.3564H19.6621V28.7974H23.1656V16.3564Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9566 18.1387H24.4531V28.7977H27.9566V18.1387Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7525 12.4189H29.249V28.7924H32.7525V12.4189Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8190_11883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBarGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bar-graph.80e0ed39b42f8c3956cc0c71d8efe1c9.svg";